
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { JurisdictionsService } from 'src/app/services/api/general-settings/jurisdictions.service';

@Component({
  selector: 'language-client',
  imports: [ReactiveFormsModule],
  templateUrl: './language-client.component.html',
  styleUrl: './language-client.component.scss',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => LanguageClientComponent),
    multi: true
  }]
})
export class LanguageClientComponent implements ControlValueAccessor, OnInit {
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() radioFormControl!: FormControl
  @Input() disabled: boolean = false;
  @Input() compactView: boolean = false;
  @Output() languageChange = new EventEmitter<any>();

  selectedLanguage: string = '';

  languages: any = [];

  constructor(private jurisdictionsService: JurisdictionsService) {
  }
  onChange: any = () => { };
  onTouch: any = () => { };
  writeValue(value: any): void {
    if (value) {
      this.selectedLanguage = value.iso3 || value.language?.iso3 || value;
    } else {
      this.selectedLanguage = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  isLanguageSelected(language: any): boolean {
    return this.selectedLanguage === language.language.languageId;
  }

  onLanguageSelect(language: any): void {
    if (!this.disabled) {
        this.selectedLanguage = language.language.languageId;
        
        this.radioFormControl.setValue(language.language.languageId, { emitEvent: false });
        
        this.languageChange.emit(language.language.languageId);

        this.onChange(language.language.languageId);
        this.onTouch();
    }
  }

  get selectedLanguageDetails() {
    if (!this.languages || !this.selectedLanguage) {
      return null;
    }    
    return this.languages.find((lang: any) =>       
        lang.language.iso3 === this.selectedLanguage
    );
  }

  ngOnInit(): void {
    this.jurisdictionsService.languages().subscribe(response => {
      this.languages = response?.data?.featureLanguages?.map((lang: any) => ({
        ...lang,
        flag: `assets/flags/${lang?.language?.iso2}.svg`
      })) || [];
      if (this.radioFormControl?.value) {
        this.writeValue(this.radioFormControl.value);
      }
    });

    if (this.radioFormControl) {
        this.radioFormControl.valueChanges.subscribe(value => {
            if (value) {
                this.writeValue(value);
            } else {
                this.selectedLanguage = '';
            }
        });
    }
  }


}
